import type { PriceListVolumeDiscountsListResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListVolumeDiscountsList = (
  priceListId: number,
  options?: ApiV2QueryOptions<PriceListVolumeDiscountsListResponseType>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.PriceTierVolumeDiscounts,
      priceListId,
      "canonical",
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `price-lists/${priceListId}/volume-discounts`,
      }).then(
        (data) =>
          apiV2AssertResponse<PriceListVolumeDiscountsListResponseType>(data)
            .data,
      ),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business },
      options,
    }),
  });
};
